import { Divider, List, ListItem, ListItemText } from "@mui/material";
import { Box, Grid } from "@mui-wrapper";
import { grey } from "@flat-ui";
import { Color } from "@styles/default-colors";
import { TextWithTooltip } from "@components/common/text-with-tooltip";

interface Props {
  /** The content to show in the profile info tab */
  contents: {
    /** Label of each row */
    label: string;

    /** The value of each row */
    value: React.ReactNode;

    /** Action button/icon of each row */
    action?: React.ReactNode;

    /** Whether to show a divider below the row */
    shouldAddDividerBelow?: boolean;
  }[];

  /** All the actions to show on the right side */
  actionButtons: React.ReactNode;
}

/** Content inside the information tab of profile */
export function ProfileInfoTab({
  contents,
  actionButtons,
}: Props): React.JSX.Element {
  return (
    <Grid container sx={{ width: "100vw", pt: "50px" }}>
      <Grid size={{ xs: 8 }}>
        <List disablePadding>
          {contents.map((content) => (
            <Box key={content.label}>
              <ListItem
                sx={{
                  py: 0.5,
                  px: 0,
                }}
              >
                <ListItemText
                  primary={content.label}
                  sx={{
                    color: grey[300],
                    minWidth: "150px",
                    maxWidth: "150px",
                    textAlign: "right" as const,
                    mr: 2,
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flex: 1,
                    minWidth: 0,
                    overflow: "hidden",
                    color: Color.grey46,
                  }}
                >
                  {typeof content.value === "string" ||
                  typeof content.value === "number" ? (
                    <Box sx={{ minWidth: 0, overflow: "hidden" }}>
                      <TextWithTooltip text={String(content.value)} />
                    </Box>
                  ) : (
                    content.value
                  )}

                  {content.action && (
                    <Box sx={{ flexShrink: 0 }}>{content.action}</Box>
                  )}
                </Box>
              </ListItem>
              {content.shouldAddDividerBelow && (
                <Divider sx={{ mx: 2, my: 1 }} />
              )}
            </Box>
          ))}
        </List>
      </Grid>
      <Grid
        container
        size={{ xs: 4 }}
        spacing={2}
        sx={{ flexDirection: "column", alignContent: "center" }}
      >
        {actionButtons}
      </Grid>
    </Grid>
  );
}
